let Test = require('@/mixins/Forms/2016/NRCA_LTI_04_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            step_1_line_h: '',
        }
    },

    methods: {

        // Add a new space to the form.
        addSpace() {
            this.spaces.push({
                step_1_line_b: '',
                step_1_line_d: '',
                step_1_line_e: 0,
                step_1_line_f: '',
                step_1_line_g: '',
                step_1_line_i: 0,
                step_2_line_b: '',
                step_2_line_d: '',
                step_2_line_e: 0,
            })
        },

        // Load data on spaces.
        loadSpaceData(index, data) {
            this.spaces.push({
                step_1_line_b: data.step_1_line_b[index],
                step_1_line_d: data.step_1_line_d[index],
                step_1_line_e: data.step_1_line_e[index],
                step_1_line_f: '',
                step_1_line_g: data.step_1_line_g[index],
                step_1_line_i: data.step_1_line_i[index],
                step_2_line_b: data.step_2_line_b[index],
                step_2_line_d: data.step_2_line_d[index],
                step_2_line_e: data.step_2_line_e[index],
            })
        },

        // Init evaluation
        evaluateTest() {
            this.spaces.forEach(space => {
                this.calculateMethodOneLine_F(space);
                this.calculateMethodOneLine_H();
                this.calculateMethodOneLine_I(space);
                this.calculateMethodTwoLine_E(space)
            });
            this.testResult = (this.functionalTest() && this.constructionInspection()) ? 1 : 0;
            this.form.testResult = !!this.testResult
        },

        // Functional Test
        functionalTest() {
            var result = true;
            this.spaces.forEach(space => {
                if (!space.step_1_line_i || !space.step_2_line_e) {
                    result = false;
                }
            });
            return result && (this.step_1_line_h >= 15);
        },

        // Method One Line F
        calculateMethodOneLine_F(space) {
            var B = this.asNumber(space.step_1_line_b);
            var D = this.asNumber(space.step_1_line_d);
            var result = (((B - D) / B) * 100).toFixed(2);
            space.step_1_line_f = this.formatResult(result);
        },

        // Method One Line H
        calculateMethodOneLine_H() {
            var sum_of_F_times_G = 0;
            var sum_of_G = 0;
            this.spaces.forEach(space => {
                var F = this.asNumber(space.step_1_line_f)
                var G = this.asNumber(space.step_1_line_g);
                sum_of_F_times_G += (F * G);
                sum_of_G += G;
            });
            var result = (sum_of_F_times_G / sum_of_G).toFixed(2);
            this.step_1_line_h = this.formatResult(result);
        },

        // Method One Line I
        calculateMethodOneLine_I(space) {
            var B = this.asNumber(space.step_1_line_b);
            var D = this.asNumber(space.step_1_line_d);
            var E = this.asNumber(space.step_1_line_e);
            var result = (B / 2);
            space.step_1_line_i = (result < (D - E)) ? 1 : 0;
        },

        // Method Two Line E
        calculateMethodTwoLine_E(space) {

            var B1 = this.asNumber(space.step_1_line_b);
            var B2 = this.asNumber(space.step_2_line_b);
            var D2 = this.asNumber(space.step_2_line_d);

            // Changes made by Mario Martinez

            // 50% of Line B
            var _50PercentB1 = (.5 * space.step_1_line_b)

            var resultOne = (B2 >= _50PercentB1) && D2 >= _50PercentB1;
            var resultTwo = (B2 < _50PercentB1) && D2 >= B2;

            var result = resultOne || resultTwo;

            if (this.isBlank(D2)) {
                space.step_2_line_e = false;
            } else {
                space.step_2_line_e = result;
            }
        }
    }
}
